import React, { useState } from 'react';
import { BarChart2Icon, PlusIcon, FilterIcon, ArrowRightIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
export const SmartReach = () => {
  const [sortField, setSortField] = useState<'name' | 'status' | 'recipients' | 'openRate' | 'clickRate' | 'replies'>('name');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const campaigns = [{
    name: 'Q2 Produkteinführung',
    status: 'Aktiv',
    recipients: 1250,
    openRate: '38.2',
    clickRate: '14.6',
    replies: 52
  }, {
    name: 'IT-Entscheider Webinar',
    status: 'Aktiv',
    recipients: 875,
    openRate: '29.7%',
    clickRate: '11.3%',
    replies: 34
  }, {
    name: 'Neukunden Follow-Up',
    status: 'Aktiv',
    recipients: 420,
    openRate: '45.2%',
    clickRate: '21.8%',
    replies: 67
  }, {
    name: 'Branchenreport 2023',
    status: 'Geplant',
    recipients: 1800,
    openRate: '0%',
    clickRate: '0%',
    replies: 0
  }];
  const handleSort = (field: typeof sortField) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  const renderSortIndicator = (field: typeof sortField) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <ChevronUpIcon size={16} className="ml-1" data-id="element-456" /> : <ChevronDownIcon size={16} className="ml-1" data-id="element-457" />;
  };
  const sortedCampaigns = [...campaigns].sort((a, b) => {
    let compareA = a[sortField];
    let compareB = b[sortField];
    // Convert percentage strings to numbers
    if (sortField === 'openRate' || sortField === 'clickRate') {
      compareA = parseFloat(compareA);
      compareB = parseFloat(compareB);
    }
    if (compareA < compareB) return sortDirection === 'asc' ? -1 : 1;
    if (compareA > compareB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  return <div className="space-y-6" data-id="element-458">
      <div className="flex items-center justify-between" data-id="element-459">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-460">Kampagnen</h2>
        <button className="px-4 py-2 bg-green-500 rounded-lg text-sm font-medium text-white flex items-center hover:bg-green-600" data-id="element-461">
          <PlusIcon size={16} className="mr-2" data-id="element-462" />
          Neue Kampagne
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-463">
        {[{
        title: 'Öffnungsrate',
        value: '32.8%',
        change: '+4.3%',
        color: 'text-blue-500'
      }, {
        title: 'Klickrate',
        value: '12.4%',
        change: '+2.1%',
        color: 'text-green-500'
      }, {
        title: 'Antwortrate',
        value: '8.7%',
        change: '+1.5%',
        color: 'text-purple-500'
      }].map((stat, index) => <div key={index} className="bg-white rounded-lg shadow p-5" data-id="element-464">
            <div className="flex justify-between items-center mb-4" data-id="element-465">
              <p className="text-sm font-medium text-gray-500" data-id="element-466">{stat.title}</p>
              <BarChart2Icon size={18} className="text-gray-400" data-id="element-467" />
            </div>
            <div className="flex items-baseline" data-id="element-468">
              <p className="text-2xl font-bold text-gray-800" data-id="element-469">{stat.value}</p>
              <p className={`ml-2 text-sm font-medium ${stat.color}`} data-id="element-470">
                {stat.change}
              </p>
            </div>
          </div>)}
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-471">
        <div className="p-5 border-b border-gray-200 flex justify-between items-center" data-id="element-472">
          <div data-id="element-473">
            <h3 className="text-lg font-medium text-gray-800" data-id="element-474">
              Aktive Kampagnen
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-475">
              Übersicht aller laufenden Kampagnen und deren Performance
            </p>
          </div>
          <button className="px-3 py-1 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 flex items-center hover:bg-gray-50" data-id="element-476">
            <FilterIcon size={14} className="mr-2 text-gray-500" data-id="element-477" />
            Filter
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-478">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-479">
            <thead className="bg-gray-50" data-id="element-480">
              <tr data-id="element-481">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('name')} data-id="element-482">
                  <div className="flex items-center" data-id="element-483">
                    Kampagne
                    {renderSortIndicator('name')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('status')} data-id="element-484">
                  <div className="flex items-center" data-id="element-485">
                    Status
                    {renderSortIndicator('status')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('recipients')} data-id="element-486">
                  <div className="flex items-center" data-id="element-487">
                    Empfänger
                    {renderSortIndicator('recipients')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('openRate')} data-id="element-488">
                  <div className="flex items-center" data-id="element-489">
                    Öffnungsrate
                    {renderSortIndicator('openRate')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('clickRate')} data-id="element-490">
                  <div className="flex items-center" data-id="element-491">
                    Klickrate
                    {renderSortIndicator('clickRate')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('replies')} data-id="element-492">
                  <div className="flex items-center" data-id="element-493">
                    Antworten
                    {renderSortIndicator('replies')}
                  </div>
                </th>
                <th scope="col" className="relative px-6 py-3" data-id="element-494">
                  <span className="sr-only" data-id="element-495">Aktionen</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-496">
              {sortedCampaigns.map((campaign, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-497">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-498">
                    <div className="text-sm font-medium text-gray-900" data-id="element-499">
                      {campaign.name}
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-500">
                      Erstellt am 15.06.2023
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-501">
                    <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${campaign.status === 'Aktiv' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-502">
                      {campaign.status}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-503">
                    <div className="text-sm text-gray-900" data-id="element-504">
                      {campaign.recipients}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-505">
                    <div className="text-sm text-gray-900" data-id="element-506">
                      {campaign.openRate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-507">
                    <div className="text-sm text-gray-900" data-id="element-508">
                      {campaign.clickRate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-509">
                    <div className="text-sm text-gray-900" data-id="element-510">
                      {campaign.replies}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-511">
                    <button className="text-green-500 hover:text-green-700 flex items-center" data-id="element-512">
                      Details
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-513" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow" data-id="element-514">
        <div className="p-5 border-b border-gray-200" data-id="element-515">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-516">
            KI-Textvorschläge
          </h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-517">
            Personalisierte Nachrichtenvorschläge basierend auf Ihren Zielkunden
          </p>
        </div>
        <div className="p-5 space-y-4" data-id="element-518">
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-519">
            <div className="flex justify-between items-start" data-id="element-520">
              <div data-id="element-521">
                <h4 className="text-sm font-medium text-gray-800" data-id="element-522">
                  Betreffzeile für IT-Entscheider
                </h4>
                <p className="text-gray-600 mt-2" data-id="element-523">
                  "Exklusive Einladung: Wie [Firma] 30% IT-Kosten einsparen
                  konnte"
                </p>
              </div>
              <button className="text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-524">
                Verwenden
              </button>
            </div>
          </div>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-525">
            <div className="flex justify-between items-start" data-id="element-526">
              <div data-id="element-527">
                <h4 className="text-sm font-medium text-gray-800" data-id="element-528">
                  Follow-Up nach Webinar
                </h4>
                <p className="text-gray-600 mt-2" data-id="element-529">
                  "Danke für Ihre Teilnahme am [Webinar-Titel]. Hier sind die
                  wichtigsten Erkenntnisse und nächsten Schritte..."
                </p>
              </div>
              <button className="text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-530">
                Verwenden
              </button>
            </div>
          </div>
          <div className="text-center mt-4" data-id="element-531">
            <button className="text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-532">
              Mehr Vorschläge anzeigen
            </button>
          </div>
        </div>
      </div>
    </div>;
};